<div>
    <div class="modal-header">
        <h5 class="mb-0">{{ title | translate }}</h5>
    </div>
    <div class="modal-body">
        <form class="k-form k-form-md" [formGroup]="form">
            <tabset >
                <tab [heading]="'activity.main_data_title' | translate">
                        <div class="mb-1 row">
                            <div class="col-12 col-md-4 col-xl-4">
                                <app-label controlName="id" class="col-form-label">{{ 'common.id' | translate }}</app-label>
                            </div>
                            <div class="col-12 col-md-8 col-xl-8">
                                <input type="text" id="id" formControlName="id" class="form-control" />
                            </div>
                        </div>
                        <div class="mb-1 row">
                            <div class="col-12 col-md-4 col-xl-4">
                                <app-label controlName="modified" class="col-form-label">{{ 'common.modified' | translate }}</app-label>
                            </div>
                            <div class="col-12 col-md-8 col-xl-8">
                                <input type="text" id="modified" formControlName="modified" class="form-control" />
                            </div>
                        </div>
                        <div class="mb-1 row">
                            <div class="col-12 col-md-4 col-xl-4">
                                <app-label controlName="stravaUsername" class="col-form-label">{{ 'activity.username' | translate }}</app-label>
                            </div>
                            <div class="col-12 col-md-8 col-xl-8">
                                <input type="text" id="stravaUsername" formControlName="stravaUsername" class="form-control" />
                            </div>
                        </div>
                        <div class="mb-1 row">
                            <div class="col-12 col-md-4 col-xl-4">
                                <app-label controlName="stravaUserId" class="col-form-label">{{ 'activity.user_id' | translate }}</app-label>
                            </div>
                            <div class="col-12 col-md-8 col-xl-8">
                                <input type="text" id="stravaUserId" formControlName="stravaUserId" class="form-control" />
                            </div>
                        </div>
                        <div class="mb-1 row">
                            <div class="col-12 col-md-4 col-xl-4">
                                <app-label controlName="activityId" class="col-form-label">{{ 'activity.id' | translate }}</app-label>
                            </div>
                            <div class="col-12 col-md-8 col-xl-8">
                                <input type="text" id="activityId" formControlName="activityId" class="form-control" />
                            </div>
                        </div>
                        <div class="mb-1 row">
                            <div class="col-12 col-md-4 col-xl-4">
                                <app-label controlName="calculatedCredit" class="col-form-label">{{ 'activity.calculated_credit' | translate }}</app-label>
                            </div>
                            <div class="col-12 col-md-8 col-xl-8">
                                <input type="text" id="calculatedCredit" formControlName="calculatedCredit" class="form-control" />
                            </div>
                        </div>
                        <div class="mb-1 row">
                            <div class="col-12 col-md-4 col-xl-4">
                                <app-label controlName="status" class="col-form-label">{{ 'common.status' | translate }}</app-label>
                            </div>
                            <div class="col-12 col-md-8 col-xl-8">
                                <input type="text" id="status" formControlName="status" class="form-control" />
                            </div>
                        </div>
                        <div class="mb-1 row">
                            <div class="col-12 col-md-4 col-xl-4">
                                <app-label controlName="error" class="col-form-label">{{ 'activity.error' | translate }}</app-label>
                            </div>
                            <div class="col-12 col-md-8 col-xl-8">
                                <textarea type="text" id="error" formControlName="error" class="form-control" rows="5"></textarea>
                            </div>
                        </div>
                </tab>
                <tab [heading]="'activity.webhook_data_title' | translate">
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="webhookRawContent" class="col-form-label">{{ 'activity.data' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <ngx-json-viewer [hidden]="webhookRawContentText" [json]="webhookRawContent" *ngIf="hasWebhookRawContent"></ngx-json-viewer>
                            <div>{{webhookRawContentText}}</div>
                        </div>
                    </div>
                </tab>
                <tab [heading]="'activity.activity_data_title' | translate">
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="activityRawContent" class="col-form-label">{{ 'activity.data' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <ngx-json-viewer [hidden]="activityRawContentText" [json]="activityRawContent" *ngIf="hasActivityRawContent"></ngx-json-viewer>
                            <div>{{activityRawContentText}}</div>
                        </div>
                    </div>
                </tab>
            </tabset>
        </form>
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="onClose()">{{ 'common.cancel' | translate }}</button>
    </div>
</div>
